import { render, staticRenderFns } from "./ConnectionTypeDetail.vue?vue&type=template&id=2938b550&scoped=true"
import script from "./ConnectionTypeDetail.vue?vue&type=script&lang=js"
export * from "./ConnectionTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./ConnectionTypeDetail.vue?vue&type=style&index=0&id=2938b550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938b550",
  null
  
)

export default component.exports